import {useQuery} from "react-query";
import getPromise from "./getPromise";
import {ajax_url} from "../routes/CurrentBriefList_Route";

const prefix_url = "/current_brief";

export const useCurrentBriefList = ()=>{
    return useQuery(ajax_url, () => getPromise(prefix_url));
}
